import React, { useState } from 'react'

import { styled } from 'styled-components'

import { Button, Modal, SectionSubtitle } from '..'
import { useStorage, useUser } from '../../context'
import { Spacer } from '../global'

const ContainerButtons = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
  gap: 20px;

  .delete-button {
    padding: 10px 20px;
    border: 0.5px solid #313131;
  }
`

enum Steps {
  INIT = 'init',
  CONFIRM = 'confirm',
  SUCCESS = 'success',
  ERROR = 'error',
}

const MODAL_INITIAL_STATE = {
  visibility: false,
  message: '',
  hasButton: false,
  step: Steps.INIT,
}

const DeleteUser = ({
  userToDeleteUID,
  userToDeleteRole,
  setActiveUserNull,
}: {
  userToDeleteUID: string
  userToDeleteRole: string
  setActiveUserNull: () => void
}) => {
  const { onEditionMode, deleteUser, userRole } = useUser()
  const { deleteUserFolder } = useStorage()
  const [showDeleteModal, setShowDeleteModal] = useState<{
    visibility: boolean
    message: string | React.ReactNode
    hasButton: boolean
    step: Steps
  }>(MODAL_INITIAL_STATE)

  const handleDelete = () => {
    setShowDeleteModal({
      visibility: true,
      message: (
        <p>
          ¿Estás seguro de que deseas eliminar este usuario? <br />
          {userToDeleteRole === 'students' &&
            `Se eliminarán tambien los bonos y cursos.`}
          <br />
          Esta acción no se puede deshacer.
        </p>
      ),
      hasButton: true,
      step: Steps.CONFIRM,
    })
  }

  const handleClose = () => {
    setShowDeleteModal(MODAL_INITIAL_STATE)
  }

  const handleConfirmDelete = async () => {
    if (!userToDeleteUID || !userToDeleteRole) return

    try {
      setShowDeleteModal(MODAL_INITIAL_STATE)
      await deleteUserFolder(userToDeleteUID)
      await deleteUser(userToDeleteUID, userToDeleteRole)

      setActiveUserNull()
    } catch (error) {
      setShowDeleteModal({
        visibility: true,
        message: <p>{String(error)}</p>,
        hasButton: true,
        step: Steps.ERROR,
      })
    }
  }

  return (
    userRole === 'admin' && (
      <>
        {showDeleteModal.visibility && (
          <Modal onClose={handleClose}>
            <Spacer height={30} />
            <SectionSubtitle fontSize={16} fontWeight={500} textAlign="center">
              <>{showDeleteModal.message}</>
            </SectionSubtitle>
            <Spacer height={30} />
            {showDeleteModal.step === Steps.CONFIRM && (
              <ContainerButtons>
                <Button
                  onClick={() => setShowDeleteModal(MODAL_INITIAL_STATE)}
                  label="Cancelar"
                />
                <Button
                  onClick={handleConfirmDelete}
                  label="Confirmar"
                  className="light-blue"
                />
              </ContainerButtons>
            )}
            {showDeleteModal.step === Steps.ERROR && (
              <ContainerButtons>
                <Button
                  label=" Cerrar"
                  onClick={() => setShowDeleteModal(MODAL_INITIAL_STATE)}
                  className="dark-grey"
                />
              </ContainerButtons>
            )}
          </Modal>
        )}
        <Button
          onClick={handleDelete}
          label="Eliminar Usuario"
          type="button"
          disabled={onEditionMode}
          className="delete"
        />
      </>
    )
  )
}

export default DeleteUser
